module.exports = __webpack_public_path__ + "img/flowChart.1766306608134.png";